import { Component, ReactNode } from "react";
import { handleAppException } from "./monitor";

type ErrorBoundaryProps = { fallback?: ReactNode; children?: ReactNode };
type ErrorBoundaryState = { hasError: boolean };

export class ErrorBoundaryMonitor extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  override componentDidCatch(error: Error, info: any) {
    handleAppException(error);
  }

  override render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }

    return this.props.children;
  }
}
